import { render, staticRenderFns } from "./CSCCommentDlg.vue?vue&type=template&id=5aa0398f"
import script from "./CSCCommentDlg.vue?vue&type=script&lang=js"
export * from "./CSCCommentDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports